'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Add reaction actions
var REQUEST_ADD_REACTION = exports.REQUEST_ADD_REACTION = 'REQUEST_ADD_REACTION';
var FAIL_ADD_REACTION = exports.FAIL_ADD_REACTION = 'FAIL_ADD_REACTION';
var SUCCESS_ADD_REACTION = exports.SUCCESS_ADD_REACTION = 'SUCCESS_ADD_REACTION';

// Remove reaction actions
var REQUEST_REMOVE_REACTION = exports.REQUEST_REMOVE_REACTION = 'REQUEST_REMOVE_REACTION';
var FAIL_REMOVE_REACTION = exports.FAIL_REMOVE_REACTION = 'FAIL_REMOVE_REACTION';
var SUCCESS_REMOVE_REACTION = exports.SUCCESS_REMOVE_REACTION = 'SUCCESS_REMOVE_REACTION';
// Manage reaction animation state
var SET_REACTION_SHOULD_ANIMATE_IN = exports.SET_REACTION_SHOULD_ANIMATE_IN = 'SET_REACTION_SHOULD_ANIMATE_IN';
var SET_REACTION_SHOULD_ANIMATE_OUT = exports.SET_REACTION_SHOULD_ANIMATE_OUT = 'SET_REACTION_SHOULD_ANIMATE_OUT';

/**
 * Add contentReaction actions
 * Allows entire contentReaction records to be added to the store
 */
var ADD_CONTENT_REACTION = exports.ADD_CONTENT_REACTION = 'ADD_CONTENT_REACTION';

// Fetch reaction users
var REQUEST_REACTION_USERS = exports.REQUEST_REACTION_USERS = 'REQUEST_REACTION_USERS';
var FAIL_RECEIVE_REACTION_USERS = exports.FAIL_RECEIVE_REACTION_USERS = 'FAIL_RECEIVE_REACTION_USERS';
var RECEIVE_REACTION_USERS = exports.RECEIVE_REACTION_USERS = 'RECEIVE_REACTION_USERS';
var FINISHED_REACTION_USERS = exports.FINISHED_REACTION_USERS = 'FINISHED_REACTION_USERS';

// Fetch tag users
var REQUEST_TAG_USERS = exports.REQUEST_TAG_USERS = 'REQUEST_TAG_USERS';
var FAIL_RECEIVE_TAG_USERS = exports.FAIL_RECEIVE_TAG_USERS = 'FAIL_RECEIVE_TAG_USERS';
var RECEIVE_TAG_USERS = exports.RECEIVE_TAG_USERS = 'RECEIVE_TAG_USERS';
var FINISHED_TAG_USERS = exports.FINISHED_TAG_USERS = 'FINISHED_TAG_USERS';

// Fetch community content metadata
var REQUEST_COMM_CONTENT_METADATA = exports.REQUEST_COMM_CONTENT_METADATA = 'REQUEST_COMM_CONTENT_METADATA ';
var FAIL_RECEIVE_COMM_CONTENT_METADATA = exports.FAIL_RECEIVE_COMM_CONTENT_METADATA = 'FAIL_RECEIVE_COMM_CONTENT_METADATA ';
var RECEIVE_COMM_CONTENT_METADATA = exports.RECEIVE_COMM_CONTENT_METADATA = 'RECEIVE_COMM_CONTENT_METADATA ';

// Fetch current user details
var REQUEST_CURRENT_USER_DETAILS = exports.REQUEST_CURRENT_USER_DETAILS = 'REQUEST_CURRENT_USER_DETAILS';
var FAIL_RECEIVE_CURRENT_USER_DETAILS = exports.FAIL_RECEIVE_CURRENT_USER_DETAILS = 'FAIL_RECEIVE_CURRENT_USER_DETAILS';
var RECEIVE_CURRENT_USER_DETAILS = exports.RECEIVE_CURRENT_USER_DETAILS = 'RECEIVE_CURRENT_USER_DETAILS';

// Request if user is following
var REQUEST_IS_FOLLOWING = exports.REQUEST_IS_FOLLOWING = 'REQUEST_IS_FOLLOWING';
var FAIL_IS_FOLLOWING = exports.FAIL_IS_FOLLOWING = 'FAIL_IS_FOLLOWING';

// Follow user
var REQUEST_FOLLOW_USER = exports.REQUEST_FOLLOW_USER = 'REQUEST_FOLLOW_USER';
var FAIL_FOLLOW_USER = exports.FAIL_FOLLOW_USER = 'FAIL_FOLLOW_USER';
var SUCCESS_FOLLOW_USER = exports.SUCCESS_FOLLOW_USER = 'SUCCESS_FOLLOW_USER';

// Unfollow user
var REQUEST_UNFOLLOW_USER = exports.REQUEST_UNFOLLOW_USER = 'REQUEST_UNFOLLOW_USER';
var FAIL_UNFOLLOW_USER = exports.FAIL_UNFOLLOW_USER = 'FAIL_UNFOLLOW_USER';
var SUCCESS_UNFOLLOW_USER = exports.SUCCESS_UNFOLLOW_USER = 'SUCCESS_UNFOLLOW_USER';

// Set user follow
var SET_USER_FOLLOW = exports.SET_USER_FOLLOW = 'SET_USER_FOLLOW';

// Suggested and Searched Athletes
var SUCCESS_GET_SUGGESTED_ATHLETES = exports.SUCCESS_GET_SUGGESTED_ATHLETES = 'SUCCESS_GET_SUGGESTED_ATHLETES';
var SUCCESS_GET_SEARCH_ATHLETES = exports.SUCCESS_GET_SEARCH_ATHLETES = 'SUCCESS_GET_SEARCH_ATHLETES';
var SUCCESS_GET_TEAMMATES = exports.SUCCESS_GET_TEAMMATES = 'SUCCESS_GET_TEAMMATES';
var SUCCESS_MODAL_GET_SEARCH_ATHLETES = exports.SUCCESS_MODAL_GET_SEARCH_ATHLETES = 'SUCCESS_MODAL_GET_SEARCH_ATHLETES';
var SUCCESS_MODAL_GET_SUGGESTED_ATHLETES = exports.SUCCESS_MODAL_GET_SUGGESTED_ATHLETES = 'SUCCESS_MODAL_GET_SUGGESTED_ATHLETES';
var UPDATE_FOLLOWING_STATUS = exports.UPDATE_FOLLOWING_STATUS = 'UPDATE_FOLLOWING_STATUS';
var UPDATE_IS_FETCHING_ATHLETES = exports.UPDATE_IS_FETCHING_ATHLETES = 'UPDATE_IS_FETCHING_ATHLETES';
var UPDATE_IS_FETCHING_SUGGESTIONS = exports.UPDATE_IS_FETCHING_SUGGESTIONS = 'UPDATE_IS_FETCHING_SUGGESTIONS';
var UPDATE_SHOW_TEAMMATES_STATUS = exports.UPDATE_SHOW_TEAMMATES_STATUS = 'UPDATE_SHOW_TEAMMATES_STATUS';
var UPDATE_SHOW_ONBOARDING_BEACON = exports.UPDATE_SHOW_ONBOARDING_BEACON = 'UPDATE_SHOW_ONBOARDING_BEACON';
var FAIL_RECEIVE_SUGGESTED_ATHLETES = exports.FAIL_RECEIVE_SUGGESTED_ATHLETES = 'FAIL_RECEIVE_SUGGESTED_ATHLETES';
var FAIL_RECEIVE_SEARCH_ATHLETES = exports.FAIL_RECEIVE_SEARCH_ATHLETES = 'FAIL_RECEIVE_SEARCH_ATHLETES';
var FAIL_FOLLOW_TEAM = exports.FAIL_FOLLOW_TEAM = 'FAIL_FOLLOW_TEAM';
var FAIL_UNFOLLOW_TEAM = exports.FAIL_UNFOLLOW_TEAM = 'FAIL_UNFOLLOW_TEAM';
var UPDATE_SHOULD_REFRESH_SUGGESTIONS = exports.UPDATE_SHOULD_REFRESH_SUGGESTIONS = 'UPDATE_SHOULD_REFRESH_SUGGESTIONS';
var UPDATE_DISPLAY_SUGGESTIONS_MODAL = exports.UPDATE_DISPLAY_SUGGESTIONS_MODAL = 'UPDATE_DISPLAY_SUGGESTIONS_MODAL';
var SHOULD_UPDATE_FOLLOWING_STATUS = exports.SHOULD_UPDATE_FOLLOWING_STATUS = 'SHOULD_UPDATE_FOLLOWING_STATUS';
var UPDATE_WIDGET_IS_FETCHING_SUGGESTIONS = exports.UPDATE_WIDGET_IS_FETCHING_SUGGESTIONS = 'UPDATE_WIDGET_IS_FETCHING_SUGGESTIONS';
var UPDATE_HAS_MORE_SUGGESTIONS = exports.UPDATE_HAS_MORE_SUGGESTIONS = 'UPDATE_HAS_MORE_SUGGESTIONS';

// Feed items
var ADD_FEED_ITEMS = exports.ADD_FEED_ITEMS = 'ADD_FEED_ITEMS';

var REQUEST_FEED_ITEM = exports.REQUEST_FEED_ITEM = 'REQUEST_FEED_ITEM';
var FAIL_FEED_ITEM = exports.FAIL_FEED_ITEM = 'FAIL_FEED_ITEM';
var RECEIVE_FEED_ITEM = exports.RECEIVE_FEED_ITEM = 'RECEIVE_FEED_ITEM';

var REQUEST_DISMISS_FEED_ITEM = exports.REQUEST_DISMISS_FEED_ITEM = 'REQUEST_DISMISS_FEED_ITEM';
var FAIL_DISMISS_FEED_ITEM = exports.FAIL_DISMISS_FEED_ITEM = 'FAIL_DISMISS_FEED_ITEM';
var SUCCESS_DISMISS_FEED_ITEM = exports.SUCCESS_DISMISS_FEED_ITEM = 'SUCCESS_DISMISS_FEED_ITEM';

var SHOW_CONFIRM_DISMISS_FEED_ITEM = exports.SHOW_CONFIRM_DISMISS_FEED_ITEM = 'SHOW_CONFIRM_DISMISS_FEED_ITEM';
var HIDE_CONFIRM_DISMISS_FEED_ITEM = exports.HIDE_CONFIRM_DISMISS_FEED_ITEM = 'HIDE_CONFIRM_DISMISS_FEED_ITEM';

// Timeline
var REQUEST_USER_TIMELINE = exports.REQUEST_USER_TIMELINE = 'REQUEST_USER_TIMELINE';
var FAIL_USER_TIMELINE = exports.FAIL_USER_TIMELINE = 'FAIL_USER_TIMELINE';
var RECEIVE_USER_TIMELINE = exports.RECEIVE_USER_TIMELINE = 'RECEIVE_USER_TIMELINE';

// Mini Profile
var REQUEST_MINI_PROFILE = exports.REQUEST_MINI_PROFILE = 'REQUEST_MINI_PROFILE';
var FAIL_MINI_PROFILE = exports.FAIL_MINI_PROFILE = 'FAIL_MINI_PROFILE';
var RECEIVE_MINI_PROFILE = exports.RECEIVE_MINI_PROFILE = 'RECEIVE_MINI_PROFILE';
var SHOW_MINI_PROFILE = exports.SHOW_MINI_PROFILE = 'SHOW_MINI_PROFILE';
var HIDE_MINI_PROFILE = exports.HIDE_MINI_PROFILE = 'HIDE_MINI_PROFILE';

// Share Content
var SHARE_CONTENT = exports.SHARE_CONTENT = 'SHARE_CONTENT';

// Theatre Modal
var THEATRE_CLOSE = exports.THEATRE_CLOSE = 'THEATRE_CLOSE';
var THEATRE_OPEN = exports.THEATRE_OPEN = 'THEATRE_OPEN';
var THEATRE_REQUEST_RECOMMENDED_VIDEOS = exports.THEATRE_REQUEST_RECOMMENDED_VIDEOS = 'THEATRE_REQUEST_RECOMMENDED_VIDEOS';
var THEATRE_FAIL_RECOMMENDED_VIDEOS = exports.THEATRE_FAIL_RECOMMENDED_VIDEOS = 'THEATRE_FAIL_RECOMMENDED_VIDEOS';
var THEATRE_RECEIVE_RECOMMENDED_VIDEOS = exports.THEATRE_RECEIVE_RECOMMENDED_VIDEOS = 'THEATRE_RECEIVE_RECOMMENDED_VIDEOS';
var THEATRE_SELECT_RECOMMENDATION = exports.THEATRE_SELECT_RECOMMENDATION = 'THEATRE_SELECT_RECOMMENDATION';
var THEATRE_SHARE_RECOMMENDATION = exports.THEATRE_SHARE_RECOMMENDATION = 'THEATRE_SHARE_RECOMMENDATION';

// Content State
var COMMUNITY_CONTENT_ENTER_VIEW = exports.COMMUNITY_CONTENT_ENTER_VIEW = 'FEED_ITEM_ENTER_VIEW';
var COMMUNITY_CONTENT_LEAVE_VIEW = exports.COMMUNITY_CONTENT_LEAVE_VIEW = 'FEED_ITEM_LEAVE_VIEW';
var COMMUNITY_CONTENT_VIDEO_PLAY = exports.COMMUNITY_CONTENT_VIDEO_PLAY = 'COMMUNITY_CONTENT_VIDEO_PLAY';
var COMMUNITY_CONTENT_VIDEO_POSITION_UPDATE = exports.COMMUNITY_CONTENT_VIDEO_POSITION_UPDATE = 'COMMUNITY_CONTENT_VIDEO_POSITION_UPDATE';
var COMMUNITY_CONTENT_VIDEO_QUARTILES_UPDATED = exports.COMMUNITY_CONTENT_VIDEO_QUARTILES_UPDATED = 'COMMUNITY_CONTENT_VIDEO_QUARTILES_UPDATED';
var COMMUNITY_CONTENT_VIDEO_STOP = exports.COMMUNITY_CONTENT_VIDEO_STOP = 'COMMUNITY_CONTENT_VIDEO_STOP';

// Header Bidding
var FETCH_HEADER_BID = exports.FETCH_HEADER_BID = 'FETCH_HEADER_BID';